// source: admpb/systemnumber.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var google_type_date_pb = require('../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
goog.exportSymbol('proto.admpb.CreateSystemNumberResponse', null, global);
goog.exportSymbol('proto.admpb.GetSystemNumberRequest', null, global);
goog.exportSymbol('proto.admpb.GetSystemNumberResponse', null, global);
goog.exportSymbol('proto.admpb.ListSystemNumberResponse', null, global);
goog.exportSymbol('proto.admpb.ListSystemNumberTypesRequest', null, global);
goog.exportSymbol('proto.admpb.ListSystemNumberTypesResponse', null, global);
goog.exportSymbol('proto.admpb.ReadSystemNumberRequest', null, global);
goog.exportSymbol('proto.admpb.ReadSystemNumberResponse', null, global);
goog.exportSymbol('proto.admpb.SysNumberSubType', null, global);
goog.exportSymbol('proto.admpb.SysNumberType', null, global);
goog.exportSymbol('proto.admpb.SystemNumber', null, global);
goog.exportSymbol('proto.admpb.SystemNumberType', null, global);
goog.exportSymbol('proto.admpb.UpdateSystemNumberResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.SystemNumber = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.SystemNumber, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.SystemNumber.displayName = 'proto.admpb.SystemNumber';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.CreateSystemNumberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.CreateSystemNumberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.CreateSystemNumberResponse.displayName = 'proto.admpb.CreateSystemNumberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.ReadSystemNumberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.ReadSystemNumberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.ReadSystemNumberRequest.displayName = 'proto.admpb.ReadSystemNumberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.ReadSystemNumberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.ReadSystemNumberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.ReadSystemNumberResponse.displayName = 'proto.admpb.ReadSystemNumberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.GetSystemNumberRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.GetSystemNumberRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.GetSystemNumberRequest.displayName = 'proto.admpb.GetSystemNumberRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.GetSystemNumberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.GetSystemNumberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.GetSystemNumberResponse.displayName = 'proto.admpb.GetSystemNumberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.UpdateSystemNumberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.UpdateSystemNumberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.UpdateSystemNumberResponse.displayName = 'proto.admpb.UpdateSystemNumberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.ListSystemNumberResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admpb.ListSystemNumberResponse.repeatedFields_, null);
};
goog.inherits(proto.admpb.ListSystemNumberResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.ListSystemNumberResponse.displayName = 'proto.admpb.ListSystemNumberResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.ListSystemNumberTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admpb.ListSystemNumberTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.admpb.ListSystemNumberTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.ListSystemNumberTypesResponse.displayName = 'proto.admpb.ListSystemNumberTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.SystemNumberType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.admpb.SystemNumberType.repeatedFields_, null);
};
goog.inherits(proto.admpb.SystemNumberType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.SystemNumberType.displayName = 'proto.admpb.SystemNumberType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.admpb.ListSystemNumberTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.admpb.ListSystemNumberTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.admpb.ListSystemNumberTypesRequest.displayName = 'proto.admpb.ListSystemNumberTypesRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.SystemNumber.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.SystemNumber.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.SystemNumber} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.SystemNumber.toObject = function(includeInstance, msg) {
  var f, obj = {
systemNumberId: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, ""),
subType: jspb.Message.getFieldWithDefault(msg, 3, ""),
fromDate: (f = msg.getFromDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
toDate: (f = msg.getToDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
rate: jspb.Message.getFieldWithDefault(msg, 6, ""),
description: jspb.Message.getFieldWithDefault(msg, 7, ""),
typeEnum: jspb.Message.getFieldWithDefault(msg, 8, 0),
subTypeEnum: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.SystemNumber}
 */
proto.admpb.SystemNumber.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.SystemNumber;
  return proto.admpb.SystemNumber.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.SystemNumber} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.SystemNumber}
 */
proto.admpb.SystemNumber.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSystemNumberId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSubType(value);
      break;
    case 4:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setFromDate(value);
      break;
    case 5:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setToDate(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setRate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDescription(value);
      break;
    case 8:
      var value = /** @type {!proto.admpb.SysNumberType} */ (reader.readEnum());
      msg.setTypeEnum(value);
      break;
    case 9:
      var value = /** @type {!proto.admpb.SysNumberSubType} */ (reader.readEnum());
      msg.setSubTypeEnum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.SystemNumber.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.SystemNumber.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.SystemNumber} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.SystemNumber.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemNumberId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFromDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getToDate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getRate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTypeEnum();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSubTypeEnum();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * optional string system_number_id = 1;
 * @return {string}
 */
proto.admpb.SystemNumber.prototype.getSystemNumberId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.SystemNumber} returns this
 */
proto.admpb.SystemNumber.prototype.setSystemNumberId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.admpb.SystemNumber.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.SystemNumber} returns this
 */
proto.admpb.SystemNumber.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string sub_type = 3;
 * @return {string}
 */
proto.admpb.SystemNumber.prototype.getSubType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.SystemNumber} returns this
 */
proto.admpb.SystemNumber.prototype.setSubType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.type.Date from_date = 4;
 * @return {?proto.google.type.Date}
 */
proto.admpb.SystemNumber.prototype.getFromDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 4));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.admpb.SystemNumber} returns this
*/
proto.admpb.SystemNumber.prototype.setFromDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.SystemNumber} returns this
 */
proto.admpb.SystemNumber.prototype.clearFromDate = function() {
  return this.setFromDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.SystemNumber.prototype.hasFromDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.type.Date to_date = 5;
 * @return {?proto.google.type.Date}
 */
proto.admpb.SystemNumber.prototype.getToDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 5));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.admpb.SystemNumber} returns this
*/
proto.admpb.SystemNumber.prototype.setToDate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.SystemNumber} returns this
 */
proto.admpb.SystemNumber.prototype.clearToDate = function() {
  return this.setToDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.SystemNumber.prototype.hasToDate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string rate = 6;
 * @return {string}
 */
proto.admpb.SystemNumber.prototype.getRate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.SystemNumber} returns this
 */
proto.admpb.SystemNumber.prototype.setRate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string description = 7;
 * @return {string}
 */
proto.admpb.SystemNumber.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.SystemNumber} returns this
 */
proto.admpb.SystemNumber.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional SysNumberType type_enum = 8;
 * @return {!proto.admpb.SysNumberType}
 */
proto.admpb.SystemNumber.prototype.getTypeEnum = function() {
  return /** @type {!proto.admpb.SysNumberType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.admpb.SysNumberType} value
 * @return {!proto.admpb.SystemNumber} returns this
 */
proto.admpb.SystemNumber.prototype.setTypeEnum = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional SysNumberSubType sub_type_enum = 9;
 * @return {!proto.admpb.SysNumberSubType}
 */
proto.admpb.SystemNumber.prototype.getSubTypeEnum = function() {
  return /** @type {!proto.admpb.SysNumberSubType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.admpb.SysNumberSubType} value
 * @return {!proto.admpb.SystemNumber} returns this
 */
proto.admpb.SystemNumber.prototype.setSubTypeEnum = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.CreateSystemNumberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.CreateSystemNumberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.CreateSystemNumberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.CreateSystemNumberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
systemNumber: (f = msg.getSystemNumber()) && proto.admpb.SystemNumber.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.CreateSystemNumberResponse}
 */
proto.admpb.CreateSystemNumberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.CreateSystemNumberResponse;
  return proto.admpb.CreateSystemNumberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.CreateSystemNumberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.CreateSystemNumberResponse}
 */
proto.admpb.CreateSystemNumberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.SystemNumber;
      reader.readMessage(value,proto.admpb.SystemNumber.deserializeBinaryFromReader);
      msg.setSystemNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.CreateSystemNumberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.CreateSystemNumberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.CreateSystemNumberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.CreateSystemNumberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemNumber();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.SystemNumber.serializeBinaryToWriter
    );
  }
};


/**
 * optional SystemNumber system_number = 1;
 * @return {?proto.admpb.SystemNumber}
 */
proto.admpb.CreateSystemNumberResponse.prototype.getSystemNumber = function() {
  return /** @type{?proto.admpb.SystemNumber} */ (
    jspb.Message.getWrapperField(this, proto.admpb.SystemNumber, 1));
};


/**
 * @param {?proto.admpb.SystemNumber|undefined} value
 * @return {!proto.admpb.CreateSystemNumberResponse} returns this
*/
proto.admpb.CreateSystemNumberResponse.prototype.setSystemNumber = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.CreateSystemNumberResponse} returns this
 */
proto.admpb.CreateSystemNumberResponse.prototype.clearSystemNumber = function() {
  return this.setSystemNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.CreateSystemNumberResponse.prototype.hasSystemNumber = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.ReadSystemNumberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.ReadSystemNumberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.ReadSystemNumberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ReadSystemNumberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
systemNumberId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.ReadSystemNumberRequest}
 */
proto.admpb.ReadSystemNumberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.ReadSystemNumberRequest;
  return proto.admpb.ReadSystemNumberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.ReadSystemNumberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.ReadSystemNumberRequest}
 */
proto.admpb.ReadSystemNumberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSystemNumberId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.ReadSystemNumberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.ReadSystemNumberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.ReadSystemNumberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ReadSystemNumberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemNumberId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string system_number_id = 1;
 * @return {string}
 */
proto.admpb.ReadSystemNumberRequest.prototype.getSystemNumberId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.ReadSystemNumberRequest} returns this
 */
proto.admpb.ReadSystemNumberRequest.prototype.setSystemNumberId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.ReadSystemNumberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.ReadSystemNumberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.ReadSystemNumberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ReadSystemNumberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
systemNumber: (f = msg.getSystemNumber()) && proto.admpb.SystemNumber.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.ReadSystemNumberResponse}
 */
proto.admpb.ReadSystemNumberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.ReadSystemNumberResponse;
  return proto.admpb.ReadSystemNumberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.ReadSystemNumberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.ReadSystemNumberResponse}
 */
proto.admpb.ReadSystemNumberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.SystemNumber;
      reader.readMessage(value,proto.admpb.SystemNumber.deserializeBinaryFromReader);
      msg.setSystemNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.ReadSystemNumberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.ReadSystemNumberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.ReadSystemNumberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ReadSystemNumberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemNumber();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.SystemNumber.serializeBinaryToWriter
    );
  }
};


/**
 * optional SystemNumber system_number = 1;
 * @return {?proto.admpb.SystemNumber}
 */
proto.admpb.ReadSystemNumberResponse.prototype.getSystemNumber = function() {
  return /** @type{?proto.admpb.SystemNumber} */ (
    jspb.Message.getWrapperField(this, proto.admpb.SystemNumber, 1));
};


/**
 * @param {?proto.admpb.SystemNumber|undefined} value
 * @return {!proto.admpb.ReadSystemNumberResponse} returns this
*/
proto.admpb.ReadSystemNumberResponse.prototype.setSystemNumber = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.ReadSystemNumberResponse} returns this
 */
proto.admpb.ReadSystemNumberResponse.prototype.clearSystemNumber = function() {
  return this.setSystemNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.ReadSystemNumberResponse.prototype.hasSystemNumber = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.GetSystemNumberRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.GetSystemNumberRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.GetSystemNumberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.GetSystemNumberRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
subType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.GetSystemNumberRequest}
 */
proto.admpb.GetSystemNumberRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.GetSystemNumberRequest;
  return proto.admpb.GetSystemNumberRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.GetSystemNumberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.GetSystemNumberRequest}
 */
proto.admpb.GetSystemNumberRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.admpb.SysNumberType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {!proto.admpb.SysNumberSubType} */ (reader.readEnum());
      msg.setSubType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.GetSystemNumberRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.GetSystemNumberRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.GetSystemNumberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.GetSystemNumberRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSubType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional SysNumberType type = 1;
 * @return {!proto.admpb.SysNumberType}
 */
proto.admpb.GetSystemNumberRequest.prototype.getType = function() {
  return /** @type {!proto.admpb.SysNumberType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.admpb.SysNumberType} value
 * @return {!proto.admpb.GetSystemNumberRequest} returns this
 */
proto.admpb.GetSystemNumberRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional SysNumberSubType sub_type = 2;
 * @return {!proto.admpb.SysNumberSubType}
 */
proto.admpb.GetSystemNumberRequest.prototype.getSubType = function() {
  return /** @type {!proto.admpb.SysNumberSubType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.admpb.SysNumberSubType} value
 * @return {!proto.admpb.GetSystemNumberRequest} returns this
 */
proto.admpb.GetSystemNumberRequest.prototype.setSubType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.GetSystemNumberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.GetSystemNumberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.GetSystemNumberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.GetSystemNumberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
systemNumber: (f = msg.getSystemNumber()) && proto.admpb.SystemNumber.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.GetSystemNumberResponse}
 */
proto.admpb.GetSystemNumberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.GetSystemNumberResponse;
  return proto.admpb.GetSystemNumberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.GetSystemNumberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.GetSystemNumberResponse}
 */
proto.admpb.GetSystemNumberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.SystemNumber;
      reader.readMessage(value,proto.admpb.SystemNumber.deserializeBinaryFromReader);
      msg.setSystemNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.GetSystemNumberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.GetSystemNumberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.GetSystemNumberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.GetSystemNumberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemNumber();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.SystemNumber.serializeBinaryToWriter
    );
  }
};


/**
 * optional SystemNumber system_number = 1;
 * @return {?proto.admpb.SystemNumber}
 */
proto.admpb.GetSystemNumberResponse.prototype.getSystemNumber = function() {
  return /** @type{?proto.admpb.SystemNumber} */ (
    jspb.Message.getWrapperField(this, proto.admpb.SystemNumber, 1));
};


/**
 * @param {?proto.admpb.SystemNumber|undefined} value
 * @return {!proto.admpb.GetSystemNumberResponse} returns this
*/
proto.admpb.GetSystemNumberResponse.prototype.setSystemNumber = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.GetSystemNumberResponse} returns this
 */
proto.admpb.GetSystemNumberResponse.prototype.clearSystemNumber = function() {
  return this.setSystemNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.GetSystemNumberResponse.prototype.hasSystemNumber = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.UpdateSystemNumberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.UpdateSystemNumberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.UpdateSystemNumberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.UpdateSystemNumberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
systemNumber: (f = msg.getSystemNumber()) && proto.admpb.SystemNumber.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.UpdateSystemNumberResponse}
 */
proto.admpb.UpdateSystemNumberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.UpdateSystemNumberResponse;
  return proto.admpb.UpdateSystemNumberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.UpdateSystemNumberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.UpdateSystemNumberResponse}
 */
proto.admpb.UpdateSystemNumberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.SystemNumber;
      reader.readMessage(value,proto.admpb.SystemNumber.deserializeBinaryFromReader);
      msg.setSystemNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.UpdateSystemNumberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.UpdateSystemNumberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.UpdateSystemNumberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.UpdateSystemNumberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemNumber();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.admpb.SystemNumber.serializeBinaryToWriter
    );
  }
};


/**
 * optional SystemNumber system_number = 1;
 * @return {?proto.admpb.SystemNumber}
 */
proto.admpb.UpdateSystemNumberResponse.prototype.getSystemNumber = function() {
  return /** @type{?proto.admpb.SystemNumber} */ (
    jspb.Message.getWrapperField(this, proto.admpb.SystemNumber, 1));
};


/**
 * @param {?proto.admpb.SystemNumber|undefined} value
 * @return {!proto.admpb.UpdateSystemNumberResponse} returns this
*/
proto.admpb.UpdateSystemNumberResponse.prototype.setSystemNumber = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.admpb.UpdateSystemNumberResponse} returns this
 */
proto.admpb.UpdateSystemNumberResponse.prototype.clearSystemNumber = function() {
  return this.setSystemNumber(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.admpb.UpdateSystemNumberResponse.prototype.hasSystemNumber = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admpb.ListSystemNumberResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.ListSystemNumberResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.ListSystemNumberResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.ListSystemNumberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ListSystemNumberResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
systemNumbersList: jspb.Message.toObjectList(msg.getSystemNumbersList(),
    proto.admpb.SystemNumber.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.ListSystemNumberResponse}
 */
proto.admpb.ListSystemNumberResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.ListSystemNumberResponse;
  return proto.admpb.ListSystemNumberResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.ListSystemNumberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.ListSystemNumberResponse}
 */
proto.admpb.ListSystemNumberResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.SystemNumber;
      reader.readMessage(value,proto.admpb.SystemNumber.deserializeBinaryFromReader);
      msg.addSystemNumbers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.ListSystemNumberResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.ListSystemNumberResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.ListSystemNumberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ListSystemNumberResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemNumbersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.admpb.SystemNumber.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SystemNumber system_numbers = 1;
 * @return {!Array<!proto.admpb.SystemNumber>}
 */
proto.admpb.ListSystemNumberResponse.prototype.getSystemNumbersList = function() {
  return /** @type{!Array<!proto.admpb.SystemNumber>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admpb.SystemNumber, 1));
};


/**
 * @param {!Array<!proto.admpb.SystemNumber>} value
 * @return {!proto.admpb.ListSystemNumberResponse} returns this
*/
proto.admpb.ListSystemNumberResponse.prototype.setSystemNumbersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.admpb.SystemNumber=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admpb.SystemNumber}
 */
proto.admpb.ListSystemNumberResponse.prototype.addSystemNumbers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.admpb.SystemNumber, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.admpb.ListSystemNumberResponse} returns this
 */
proto.admpb.ListSystemNumberResponse.prototype.clearSystemNumbersList = function() {
  return this.setSystemNumbersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admpb.ListSystemNumberTypesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.ListSystemNumberTypesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.ListSystemNumberTypesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.ListSystemNumberTypesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ListSystemNumberTypesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
systemNumberTypesList: jspb.Message.toObjectList(msg.getSystemNumberTypesList(),
    proto.admpb.SystemNumberType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.ListSystemNumberTypesResponse}
 */
proto.admpb.ListSystemNumberTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.ListSystemNumberTypesResponse;
  return proto.admpb.ListSystemNumberTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.ListSystemNumberTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.ListSystemNumberTypesResponse}
 */
proto.admpb.ListSystemNumberTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.admpb.SystemNumberType;
      reader.readMessage(value,proto.admpb.SystemNumberType.deserializeBinaryFromReader);
      msg.addSystemNumberTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.ListSystemNumberTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.ListSystemNumberTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.ListSystemNumberTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ListSystemNumberTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemNumberTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.admpb.SystemNumberType.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SystemNumberType system_number_types = 1;
 * @return {!Array<!proto.admpb.SystemNumberType>}
 */
proto.admpb.ListSystemNumberTypesResponse.prototype.getSystemNumberTypesList = function() {
  return /** @type{!Array<!proto.admpb.SystemNumberType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.admpb.SystemNumberType, 1));
};


/**
 * @param {!Array<!proto.admpb.SystemNumberType>} value
 * @return {!proto.admpb.ListSystemNumberTypesResponse} returns this
*/
proto.admpb.ListSystemNumberTypesResponse.prototype.setSystemNumberTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.admpb.SystemNumberType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.admpb.SystemNumberType}
 */
proto.admpb.ListSystemNumberTypesResponse.prototype.addSystemNumberTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.admpb.SystemNumberType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.admpb.ListSystemNumberTypesResponse} returns this
 */
proto.admpb.ListSystemNumberTypesResponse.prototype.clearSystemNumberTypesList = function() {
  return this.setSystemNumberTypesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.admpb.SystemNumberType.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.SystemNumberType.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.SystemNumberType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.SystemNumberType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.SystemNumberType.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, ""),
subTypesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.SystemNumberType}
 */
proto.admpb.SystemNumberType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.SystemNumberType;
  return proto.admpb.SystemNumberType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.SystemNumberType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.SystemNumberType}
 */
proto.admpb.SystemNumberType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.addSubTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.SystemNumberType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.SystemNumberType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.SystemNumberType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.SystemNumberType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.admpb.SystemNumberType.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.admpb.SystemNumberType} returns this
 */
proto.admpb.SystemNumberType.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string sub_types = 2;
 * @return {!Array<string>}
 */
proto.admpb.SystemNumberType.prototype.getSubTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.admpb.SystemNumberType} returns this
 */
proto.admpb.SystemNumberType.prototype.setSubTypesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.admpb.SystemNumberType} returns this
 */
proto.admpb.SystemNumberType.prototype.addSubTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.admpb.SystemNumberType} returns this
 */
proto.admpb.SystemNumberType.prototype.clearSubTypesList = function() {
  return this.setSubTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.admpb.ListSystemNumberTypesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.admpb.ListSystemNumberTypesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.admpb.ListSystemNumberTypesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ListSystemNumberTypesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.admpb.ListSystemNumberTypesRequest}
 */
proto.admpb.ListSystemNumberTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.admpb.ListSystemNumberTypesRequest;
  return proto.admpb.ListSystemNumberTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.admpb.ListSystemNumberTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.admpb.ListSystemNumberTypesRequest}
 */
proto.admpb.ListSystemNumberTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.admpb.ListSystemNumberTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.admpb.ListSystemNumberTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.admpb.ListSystemNumberTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.admpb.ListSystemNumberTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.admpb.SysNumberType = {
  SYS_NUMBER_TYPE_UNSPECIFIED: 0,
  SYS_NUMBER_TYPE_TAF_FEE: 1,
  SYS_NUMBER_TYPE_RESTING_BALANCE: 2,
  SYS_NUMBER_TYPE_MARGIN_INTEREST_RATE: 3,
  SYS_NUMBER_TYPE_FWH: 4,
  SYS_NUMBER_TYPE_SWH: 5,
  SYS_NUMBER_TYPE_CASH_BALANCE_INTEREST_RATE: 6,
  SYS_NUMBER_TYPE_REGULATORY_FEE: 7,
  SYS_NUMBER_TYPE_INTEREST_ON_CASH: 8
};

/**
 * @enum {number}
 */
proto.admpb.SysNumberSubType = {
  SYS_NUMBER_SUB_TYPE_UNSPECIFIED: 0,
  SYS_NUMBER_SUB_TYPE_QTY_LIMIT: 1,
  SYS_NUMBER_SUB_TYPE_ONE_ONE_ONE_FIVE: 2,
  SYS_NUMBER_SUB_TYPE_DEBIT_RATE: 3,
  SYS_NUMBER_SUB_TYPE_VT: 4,
  SYS_NUMBER_SUB_TYPE_MIN_RATE: 5,
  SYS_NUMBER_SUB_TYPE_MAX_RATE: 6,
  SYS_NUMBER_SUB_TYPE_CREDIT_RATE: 7,
  SYS_NUMBER_SUB_TYPE_REGULATORY_FEE_SUB: 8,
  SYS_NUMBER_SUB_TYPE_FED_RATE: 9
};

goog.object.extend(exports, proto.admpb);
